import { useLazyQuery } from "react-apollo"

import GET_PROGRAM_NAME_COUNT from "../queries/kitStatus/getProgramNameCount"

const useProgramNameCount = (options = {}) => {
  return useLazyQuery(GET_PROGRAM_NAME_COUNT(options?.variables), options)
}

export default useProgramNameCount
